<template>
  <div class="scroller">
    <div class="resource">
      <header class="resource__header">
        <h2 class="resource__heading" v-if="action === 'create'">New screen</h2>
        <h2 class="resource__heading" v-else>Edit screen</h2>

        <div class="formToggle" v-if="action === 'edit'">
          <button type="button" @click="showClone = !showClone" class="btn btn--primary">Clone screen</button>
          <button type="button" @click="showTurnOnOffTime = !showTurnOnOffTime" class="btn btn--primary">Turn on/off time</button>
        </div>
      </header>

      <CloneScreen :slider="slider" :slides="slides" v-if="action === 'edit' && showClone"/>
      <TurnOnOffTime v-if="action === 'edit' && showTurnOnOffTime"/>

      <form class="form" @submit.prevent="onSubmit">
        <div class="form__row mb2">
          <div class="grid">
            <div class="grid__column--nine">
              <div class="form__group">
                <label class="form__label" for="title">Screen title:</label>
                <span class="form__error" v-if="errors.has('title')">{{ errors.first('title') }}</span>
                <input
                  type="text" id="title" name="title"
                  class="form__input" :class="{ 'form__input--error': errors.has('title') }"
                  v-validate="{ required: true }"
                  v-model="slider.title"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="screen_ip">Screen ip:</label>
                <span class="form__error" v-if="errors.has('screen_ip')">{{ errors.first('screen_ip') }}</span>
                <input
                  type="text" id="screen_ip" name="screen_ip"
                  class="form__input mb0" :class="{ 'form__input--error': errors.has('screen_ip') }"
                  v-validate="{ required: true }"
                  v-model="slider.additionals.screen_ip"
                />
              </div>
            </div>
            <div class="grid__column--three">
              <button type="submit" class="btn btn--primary btn--nextToInput" v-if="action === 'create'">PUBLISH</button>
              <button type="submit" class="btn btn--primary btn--nextToInput" v-else>UPDATE</button>
            </div>
          </div>
        </div>

        <div v-if="slides.length > 0">
          <draggable class="slides__header" v-model="slides">
            <li v-for="slide in slides" :key="slide.id" class="slides__headerTitle" :class="{'slides__headerTitle--active': (slide == activeSlide)}" @click="setActive(slide)">
              <template v-if="slide.title">{{ slide.title }}</template>
              <template v-else>Slide</template>
            </li>
            <li class="slides__headerTitle slides__headerTitle--add" @click="addSlide">Add slide</li>
          </draggable>
          <Screen v-bind:activeSlide.sync="activeSlide" v-bind:slides.sync="slides" @deleteSlide="deleteSlide"/>
        </div>
        <div class="center" v-else>
          <template v-if="action == 'edit'">
            <h2>Let's add your first slide</h2>
            <button type="button" class="btn btn--primary" @click="addSlide">Add slide</button>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types.js'
import Slider from '@/model/Slider'
import SlideModal from '@/model/Slide'
import Screen from '@/components/Screen/Screen'
import CloneScreen from '@/components/Screen/CloneScreen'
import TurnOnOffTime from '@/components/Screen/TurnOnOffTime'
import {submitResource} from '@/helpers/handleForm'
import draggable from 'vuedraggable'

export default {
  components: {
    Screen, CloneScreen, TurnOnOffTime, draggable
  },
  computed: {
    sliders () {
      return this.$store.getters[types.ALL_SLIDERS]
    }
  },
  props: {
    action: {
      type: String,
      default: 'edit'
    },
    slider: {
      type: Object,
      default () {
        return {
          title: '',
          additionals: {}
        }
      }
    }
  },
  data () {
    return {
      slides: [],
      activeSlide: {},
      showClone: false,
      showTurnOnOffTime: false,
      isLoading: true
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      Slider.show(this.$route.params.id).then((response) => {
        this.slides = response.data.data.slides
        this.isLoading = false
        if (this.slides.length > 0) {
          this.activeSlide = this.slides[0]
        }
      })
    },
    onSubmit () {
      if (this.sliders.data.length) {
        this.slider.additionals.turn_on_time = this.sliders.data[0].additionals.turn_on_time
        this.slider.additionals.turn_off_time = this.sliders.data[0].additionals.turn_off_time
      }

      submitResource(this.$validator, Slider, this.slider, this.action)
    },
    addSlide () {
      let slide = this.defaultSlide()
      this.slides.push(slide)
      this.setActive(slide)
    },
    setActive (slide) {
      this.activeSlide = slide
    },
    deleteSlide () {
      swal({
        title: 'Are you sure you wish to delete this slide?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          SlideModal.delete(this.slider.id, this.activeSlide).then((response) => {
            this.slides.splice(this.slides.indexOf(this.activeSlide), 1)

            if (this.slides.length > 0) {
              this.activeSlide = this.slides[0]
            } else {
              this.activeSlide = {}
            }

            axios.post(`/sliders/${this.$route.params.id}/change_updated_at`)

            this.$snotify.success('Successfully deleted.')
          })
        }
      })
    },
    defaultSlide () {
      return {
        additionals: {},
        active: true,
        slider_id: this.$route.params.id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Screen/ScreenForm.vue